// @ts-nocheck

import memoize from 'memoize-state';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

import useMergeProps from '../../../../hooks/useMergeProps';
import {
  initBasket as initBasketAction,
  initPublicBasket as initPublicBasketAction,
  initHistoryBasket as initHistoryBasketAction,
  fillPrechecks as fillPrechecksAction,
} from '../../actions/basket';
import GridsBasketRouteUpdate from '../../components/basket/GridsBasketRouteUpdate';
import { getUpdateBasketSelector } from '../../selectors/basket';

const legacySelector = memoize(getUpdateBasketSelector);

type GridsBasketRouteUpdateContainerProps = {
  className?: string;
};

const GridsBasketRouteUpdateContainer = (ownProps: GridsBasketRouteUpdateContainerProps) => {
  const dispatch = useDispatch();

  const match = useRouteMatch();
  const history = useHistory();
  const location = useLocation();

  const selectedProps = useSelector((state) => legacySelector(state, { match, history, location }));

  const initBasket = useCallback(
    ({ poolId, selections }) => {
      dispatch(initBasketAction({ poolId, selections }));
    },
    [dispatch],
  );

  const initPublicBasket = useCallback(
    ({ poolId, gridReference }) => {
      dispatch(initPublicBasketAction({ poolId, gridReference }));
    },
    [dispatch],
  );

  const initHistoryBasket = useCallback(
    ({ poolId, gridReference }) => {
      dispatch(initHistoryBasketAction({ poolId, gridReference }));
    },
    [dispatch],
  );

  const fillPrechecks = useCallback(
    ({ poolId, selections }) => {
      dispatch(fillPrechecksAction({ poolId, selections }));
    },
    [dispatch],
  );

  const otherProps = useMemo(
    () => ({
      initBasket,
      initPublicBasket,
      initHistoryBasket,
      fillPrechecks,
    }),
    [fillPrechecks, initBasket, initHistoryBasket, initPublicBasket],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GridsBasketRouteUpdate {...enhancedProps} />;
};

export default GridsBasketRouteUpdateContainer;
